import React, { useState, useRef, useEffect } from 'react';
import axios from 'axios';
import { marked } from 'marked';
import { useNavigate, useParams } from 'react-router-dom';
import { BASELINE } from '../../util';
import 'katex/dist/katex.min.css';
import QuizEditModal from './quiz_Edit';
import ContentRegeneratorModal from './regenerate';

// Import CSS files for styling
import './tufte.css';

const LessonEditor = () => {
    const [lessonType, setLessonType] = useState('html');
    // "content" 상태로 파일 내용을 관리합니다.
    const [content, setContent] = useState('');
    const textareaRef = useRef(null);
    const previewRef = useRef(null);
    const navigate = useNavigate();
    const { cid, lid } = useParams(); // cid: course id, lid: lesson id

    // 기존 state들
    const [lessonDetail, setLessonDetail] = useState(null);
    const [courseDetail, setCourseDetail] = useState(null);
    const [isKatexRendered, setIsKatexRendered] = useState(false);
    // 전체 lesson 목록 (order_index 순)
    const [allLessons, setAllLessons] = useState([]);
    const [isQuizEditModalOpen, setIsQuizEditModalOpen] = useState(false);
    // Add state for the new ContentRegeneratorModal
    const [isRegenerateModalOpen, setIsRegenerateModalOpen] = useState(false);

    // Create Lesson Modal state
    const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
    const [newLessonTitle, setNewLessonTitle] = useState('');
    const [newLessonType, setNewLessonType] = useState('html');
    const [newLessonTopic, setNewLessonTopic] = useState('algebra');
    const [newLessonQuestions, setNewLessonQuestions] = useState('');
    const [newLessonContent, setNewLessonContent] = useState('');
    const [newLessonStatus, setNewLessonStatus] = useState('open');

    // quiz topic 옵션
    const quizTopics = [
        { value: 'algebra', label: 'Algebra', max: 10 },
        { value: 'triangle', label: 'Triangle', max: 20 },
    ];

    const handleContentRegenerated = (regeneratedContent) => {
        setContent(regeneratedContent);
    };
    /*
        useEffect(() => {
            const loadAndInlineCSS = async () => {
                try {
                    // tufte.css와 non_tufte.css 두 파일 모두 가져온다고 가정
                    const [tufteRes, nonTufteRes] = await Promise.all([
                        axios.get('http://localhost:8080/Class_Materials/tufte.css', { responseType: 'text' }),
                        axios.get('http://localhost:8080/Class_Materials/non_tufte.css', { responseType: 'text' })
                    ]);
    
                    // document.head에 style 태그를 생성하여 삽입
                    const styleTag = document.createElement('style');
                    styleTag.innerHTML = tufteRes.data + '\n' + nonTufteRes.data;
                    document.head.appendChild(styleTag);
                } catch (error) {
                    console.error('Error loading CSS inline:', error);
                }
            };
    
            loadAndInlineCSS();
        }, []);
    */

    useEffect(() => {
        window.solutionToggle = (elem, id) => {
            const solutionEl = document.getElementById(`question-solution-${id}`);
            if (!solutionEl) {
                console.error(`No solution element found for id: ${id}`);
                return;
            }
            const currentDisplay = window.getComputedStyle(solutionEl).display;
            if (currentDisplay === 'none') {
                solutionEl.style.display = 'block';
                elem.textContent = '−';
            } else {
                solutionEl.style.display = 'none';
                elem.textContent = '+';
            }
        };

        return () => {
            delete window.solutionToggle;
        };
    }, []);


    useEffect(() => {
        // 퀴즈 네비게이션 기능 설정
        const setupQuizNavigation = () => {
            const q1Btn = document.getElementById('q1-btn');
            const q2Btn = document.getElementById('q2-btn');
            const q3Btn = document.getElementById('q3-btn');
            const q4Btn = document.getElementById('q4-btn');
            const q5Btn = document.getElementById('q5-btn');
            const q6Btn = document.getElementById('q6-btn');

            const question1 = document.getElementById('question1');
            const question2 = document.getElementById('question2');
            const question3 = document.getElementById('question3');
            const question4 = document.getElementById('question4');
            const question5 = document.getElementById('question5');
            const question6 = document.getElementById('question6');

            // 각 버튼이 있는지 확인하고 이벤트 리스너 추가
            if (q1Btn && question1) {
                q1Btn.addEventListener('click', function () {
                    question1.style.display = 'block';
                    if (question2) question2.style.display = 'none';
                    if (question3) question3.style.display = 'none';
                    if (question4) question4.style.display = 'none';
                    if (question5) question5.style.display = 'none';
                    if (question6) question6.style.display = 'none';

                    q1Btn.classList.add('active');
                    if (q2Btn) q2Btn.classList.remove('active');
                    if (q3Btn) q3Btn.classList.remove('active');
                    if (q4Btn) q4Btn.classList.remove('active');
                    if (q5Btn) q5Btn.classList.remove('active');
                    if (q6Btn) q6Btn.classList.remove('active');
                });
            }

            if (q2Btn && question2) {
                q2Btn.addEventListener('click', function () {
                    if (question1) question1.style.display = 'none';
                    question2.style.display = 'block';
                    if (question3) question3.style.display = 'none';
                    if (question4) question4.style.display = 'none';
                    if (question5) question5.style.display = 'none';
                    if (question6) question6.style.display = 'none';

                    if (q1Btn) q1Btn.classList.remove('active');
                    q2Btn.classList.add('active');
                    if (q3Btn) q3Btn.classList.remove('active');
                    if (q4Btn) q4Btn.classList.remove('active');
                    if (q5Btn) q5Btn.classList.remove('active');
                    if (q6Btn) q6Btn.classList.remove('active');
                });
            }

            if (q3Btn && question3) {
                q3Btn.addEventListener('click', function () {
                    if (question1) question1.style.display = 'none';
                    if (question2) question2.style.display = 'none';
                    question3.style.display = 'block';
                    if (question4) question4.style.display = 'none';
                    if (question5) question5.style.display = 'none';
                    if (question6) question6.style.display = 'none';

                    if (q1Btn) q1Btn.classList.remove('active');
                    if (q2Btn) q2Btn.classList.remove('active');
                    q3Btn.classList.add('active');
                    if (q4Btn) q4Btn.classList.remove('active');
                    if (q5Btn) q5Btn.classList.remove('active');
                    if (q6Btn) q6Btn.classList.remove('active');
                });
            }

            if (q4Btn && question4) {
                q4Btn.addEventListener('click', function () {
                    if (question1) question1.style.display = 'none';
                    if (question2) question2.style.display = 'none';
                    if (question3) question3.style.display = 'none';
                    question4.style.display = 'block';
                    if (question5) question5.style.display = 'none';
                    if (question6) question6.style.display = 'none';

                    if (q1Btn) q1Btn.classList.remove('active');
                    if (q2Btn) q2Btn.classList.remove('active');
                    if (q3Btn) q3Btn.classList.remove('active');
                    q4Btn.classList.add('active');
                    if (q5Btn) q5Btn.classList.remove('active');
                    if (q6Btn) q6Btn.classList.remove('active');
                });
            }

            if (q5Btn && question5) {
                q5Btn.addEventListener('click', function () {
                    if (question1) question1.style.display = 'none';
                    if (question2) question2.style.display = 'none';
                    if (question3) question3.style.display = 'none';
                    if (question4) question4.style.display = 'none';
                    question5.style.display = 'block';
                    if (question6) question6.style.display = 'none';

                    if (q1Btn) q1Btn.classList.remove('active');
                    if (q2Btn) q2Btn.classList.remove('active');
                    if (q3Btn) q3Btn.classList.remove('active');
                    if (q4Btn) q4Btn.classList.remove('active');
                    q5Btn.classList.add('active');
                    if (q6Btn) q6Btn.classList.remove('active');
                });
            }

            if (q6Btn && question6) {
                q6Btn.addEventListener('click', function () {
                    if (question1) question1.style.display = 'none';
                    if (question2) question2.style.display = 'none';
                    if (question3) question3.style.display = 'none';
                    if (question4) question4.style.display = 'none';
                    if (question5) question5.style.display = 'none';
                    question6.style.display = 'block';

                    if (q1Btn) q1Btn.classList.remove('active');
                    if (q2Btn) q2Btn.classList.remove('active');
                    if (q3Btn) q3Btn.classList.remove('active');
                    if (q4Btn) q4Btn.classList.remove('active');
                    if (q5Btn) q5Btn.classList.remove('active');
                    q6Btn.classList.add('active');
                });
            }
        };

        // 솔루션 토글 기능 정의 - 전역으로 추가
        window.toggleSolutionAlt = (elem) => {
            // 클릭한 요소의 가장 가까운 .solution-container를 찾습니다.
            const container = elem.closest('.solution-container');
            if (!container) {
                console.error('No .solution-container element found.');
                return;
            }

            // 그 안에서 .solution-content 요소를 선택합니다.
            const content = container.querySelector('.solution-content');
            // 토글 버튼 내부의 .solution-button을 찾습니다.
            const button = elem.querySelector('.solution-button');

            if (!content) {
                console.error('No .solution-content element found.');
                return;
            }

            if (content.style.display === 'block') {
                content.style.display = 'none';
                if (button) button.textContent = '+';
            } else {
                content.style.display = 'block';
                if (button) button.textContent = '−';
            }
        };

        // 일반 솔루션 토글 기능 정의
        window.toggleSolution = (elem) => {
            // 가장 가까운 .question 요소 내에서 .question-solution을 찾습니다.
            const questionContainer = elem.closest('.question');
            if (!questionContainer) {
                console.error('No .question element found.');
                return;
            }
            const content = questionContainer.querySelector('.question-solution');
            if (!content) {
                console.error('No .question-solution element found.');
                return;
            }

            if (content.style.display === 'block') {
                content.style.display = 'none';
                elem.textContent = '+';
            } else {
                content.style.display = 'block';
                elem.textContent = '−';
            }
        };

        // 답변 확인 기능 정의
        window.checkAnswers = (btn) => {
            const matchingTable = btn.previousElementSibling;
            if (!matchingTable) {
                console.error('No matching table found.');
                return;
            }

            const inputs = matchingTable.querySelectorAll('.matching-input');
            if (inputs.length === 0) {
                console.error('No .matching-input elements found.');
                return;
            }

            inputs.forEach(input => {
                const correctAnswer = input.getAttribute('data-correct');
                const userAnswer = input.value ? input.value.toUpperCase() : '';

                if (userAnswer === correctAnswer) {
                    input.style.backgroundColor = '#34D399';
                    input.style.color = '#064E3B';
                    input.style.borderColor = '#34D399';
                } else {
                    input.style.backgroundColor = '#F87171';
                    input.style.color = '#7F1D1D';
                    input.style.borderColor = '#F87171';
                }
            });
        };

        // 솔루션 토글 버튼에 이벤트 리스너 추가
        const setupSolutionToggles = () => {
            const solutionToggles = document.querySelectorAll('.solution-toggle');
            solutionToggles.forEach(toggle => {
                // 이미 이벤트가 등록되었는지 확인
                if (!toggle.getAttribute('data-event-attached')) {
                    if (toggle.getAttribute('data-solution-type') === 'alt') {
                        // onclick 속성 제거하고 이벤트 리스너 추가
                        toggle.removeAttribute('onclick');
                        toggle.addEventListener('click', function () {
                            window.toggleSolutionAlt(this);
                        });
                    } else {
                        toggle.addEventListener('click', function () {
                            window.toggleSolution(this);
                        });
                    }
                    toggle.setAttribute('data-event-attached', 'true');
                }
            });
        };

        // 탭 기능 설정
        const setupAllTabs = () => {
            // 기능어 탭 (positive/neutral/negative)
            const setupFunctionWordsTabs = () => {
                const allBtn = document.getElementById('all-btn');
                const positiveBtn = document.getElementById('positive-btn');
                const neutralBtn = document.getElementById('neutral-btn');
                const negativeBtn = document.getElementById('negative-btn');

                const positiveCard = document.getElementById('positive-card');
                const neutralCard = document.getElementById('neutral-card');
                const negativeCard = document.getElementById('negative-card');

                // 모든 요소가 존재하는지 확인
                if (!allBtn || !positiveBtn || !neutralBtn || !negativeBtn ||
                    !positiveCard || !neutralCard || !negativeCard) {
                    // 요소가 없으면 이 탭 설정을 건너뜁니다
                    return;
                }

                // All 탭 클릭 이벤트
                allBtn.addEventListener('click', function () {
                    positiveCard.style.display = 'block';
                    neutralCard.style.display = 'block';
                    negativeCard.style.display = 'block';

                    allBtn.classList.add('active');
                    positiveBtn.classList.remove('active');
                    neutralBtn.classList.remove('active');
                    negativeBtn.classList.remove('active');
                });

                // Positive 탭 클릭 이벤트
                positiveBtn.addEventListener('click', function () {
                    positiveCard.style.display = 'block';
                    neutralCard.style.display = 'none';
                    negativeCard.style.display = 'none';

                    allBtn.classList.remove('active');
                    positiveBtn.classList.add('active');
                    neutralBtn.classList.remove('active');
                    negativeBtn.classList.remove('active');
                });

                // Neutral 탭 클릭 이벤트
                neutralBtn.addEventListener('click', function () {
                    positiveCard.style.display = 'none';
                    neutralCard.style.display = 'block';
                    negativeCard.style.display = 'none';

                    allBtn.classList.remove('active');
                    positiveBtn.classList.remove('active');
                    neutralBtn.classList.add('active');
                    negativeBtn.classList.remove('active');
                });

                // Negative 탭 클릭 이벤트
                negativeBtn.addEventListener('click', function () {
                    positiveCard.style.display = 'none';
                    neutralCard.style.display = 'none';
                    negativeCard.style.display = 'block';

                    allBtn.classList.remove('active');
                    positiveBtn.classList.remove('active');
                    neutralBtn.classList.remove('active');
                    negativeBtn.classList.add('active');
                });
            };

            // A/B/C 패턴 탭 설정
            const setupPatternABCTabs = () => {
                const patternABtn = document.getElementById('pattern-a-btn');
                const patternBBtn = document.getElementById('pattern-b-btn');
                const patternCBtn = document.getElementById('pattern-c-btn');

                const patternA = document.getElementById('pattern-a');
                const patternB = document.getElementById('pattern-b');
                const patternC = document.getElementById('pattern-c');

                // 모든 요소가 존재하는지 확인
                if (!patternABtn || !patternBBtn || !patternCBtn ||
                    !patternA || !patternB || !patternC) {
                    // 요소가 없으면 이 탭 설정을 건너뜁니다
                    return;
                }

                // Pattern A 탭 클릭 이벤트
                patternABtn.addEventListener('click', function () {
                    patternA.style.display = 'block';
                    patternB.style.display = 'none';
                    patternC.style.display = 'none';

                    patternABtn.classList.add('active');
                    patternBBtn.classList.remove('active');
                    patternCBtn.classList.remove('active');
                });

                // Pattern B 탭 클릭 이벤트
                patternBBtn.addEventListener('click', function () {
                    patternA.style.display = 'none';
                    patternB.style.display = 'block';
                    patternC.style.display = 'none';

                    patternABtn.classList.remove('active');
                    patternBBtn.classList.add('active');
                    patternCBtn.classList.remove('active');
                });

                // Pattern C 탭 클릭 이벤트
                patternCBtn.addEventListener('click', function () {
                    patternA.style.display = 'none';
                    patternB.style.display = 'none';
                    patternC.style.display = 'block';

                    patternABtn.classList.remove('active');
                    patternBBtn.classList.remove('active');
                    patternCBtn.classList.add('active');
                });
            };

            // D/E/F/G/H/I 패턴 탭 설정
            const setupPatternDEFGHITabs = () => {
                const patternDBtn = document.getElementById('pattern-d-btn');
                const patternEBtn = document.getElementById('pattern-e-btn');
                const patternFBtn = document.getElementById('pattern-f-btn');
                const patternGBtn = document.getElementById('pattern-g-btn');
                const patternHBtn = document.getElementById('pattern-h-btn');
                const patternIBtn = document.getElementById('pattern-i-btn');

                const patternD = document.getElementById('pattern-d');
                const patternE = document.getElementById('pattern-e');
                const patternF = document.getElementById('pattern-f');
                const patternG = document.getElementById('pattern-g');
                const patternH = document.getElementById('pattern-h');
                const patternI = document.getElementById('pattern-i');

                // 모든 요소가 존재하는지 확인
                if (!patternDBtn || !patternEBtn || !patternFBtn || !patternGBtn || !patternHBtn || !patternIBtn ||
                    !patternD || !patternE || !patternF || !patternG || !patternH || !patternI) {
                    // 요소가 없으면 이 탭 설정을 건너뜁니다
                    return;
                }

                // Pattern D 버튼 (Compound Subjects)
                patternDBtn.addEventListener('click', function () {
                    patternD.style.display = 'block';
                    patternE.style.display = 'none';
                    patternF.style.display = 'none';
                    patternG.style.display = 'none';
                    patternH.style.display = 'none';
                    patternI.style.display = 'none';

                    patternDBtn.classList.add('active');
                    patternEBtn.classList.remove('active');
                    patternFBtn.classList.remove('active');
                    patternGBtn.classList.remove('active');
                    patternHBtn.classList.remove('active');
                    patternIBtn.classList.remove('active');
                });

                // Pattern E 버튼 (There is/are)
                patternEBtn.addEventListener('click', function () {
                    patternD.style.display = 'none';
                    patternE.style.display = 'block';
                    patternF.style.display = 'none';
                    patternG.style.display = 'none';
                    patternH.style.display = 'none';
                    patternI.style.display = 'none';

                    patternDBtn.classList.remove('active');
                    patternEBtn.classList.add('active');
                    patternFBtn.classList.remove('active');
                    patternGBtn.classList.remove('active');
                    patternHBtn.classList.remove('active');
                    patternIBtn.classList.remove('active');
                });

                // 나머지 패턴 버튼들에 대한 이벤트 리스너...
                // Pattern F 버튼 (Gerunds)
                patternFBtn.addEventListener('click', function () {
                    patternD.style.display = 'none';
                    patternE.style.display = 'none';
                    patternF.style.display = 'block';
                    patternG.style.display = 'none';
                    patternH.style.display = 'none';
                    patternI.style.display = 'none';

                    patternDBtn.classList.remove('active');
                    patternEBtn.classList.remove('active');
                    patternFBtn.classList.add('active');
                    patternGBtn.classList.remove('active');
                    patternHBtn.classList.remove('active');
                    patternIBtn.classList.remove('active');
                });

                // Pattern G 버튼 (Collective Nouns)
                patternGBtn.addEventListener('click', function () {
                    patternD.style.display = 'none';
                    patternE.style.display = 'none';
                    patternF.style.display = 'none';
                    patternG.style.display = 'block';
                    patternH.style.display = 'none';
                    patternI.style.display = 'none';

                    patternDBtn.classList.remove('active');
                    patternEBtn.classList.remove('active');
                    patternFBtn.classList.remove('active');
                    patternGBtn.classList.add('active');
                    patternHBtn.classList.remove('active');
                    patternIBtn.classList.remove('active');
                });

                // Pattern H 버튼 (That/What)
                patternHBtn.addEventListener('click', function () {
                    patternD.style.display = 'none';
                    patternE.style.display = 'none';
                    patternF.style.display = 'none';
                    patternG.style.display = 'none';
                    patternH.style.display = 'block';
                    patternI.style.display = 'none';

                    patternDBtn.classList.remove('active');
                    patternEBtn.classList.remove('active');
                    patternFBtn.classList.remove('active');
                    patternGBtn.classList.remove('active');
                    patternHBtn.classList.add('active');
                    patternIBtn.classList.remove('active');
                });

                // Pattern I 버튼 (Indefinite Pronouns)
                patternIBtn.addEventListener('click', function () {
                    patternD.style.display = 'none';
                    patternE.style.display = 'none';
                    patternF.style.display = 'none';
                    patternG.style.display = 'none';
                    patternH.style.display = 'none';
                    patternI.style.display = 'block';

                    patternDBtn.classList.remove('active');
                    patternEBtn.classList.remove('active');
                    patternFBtn.classList.remove('active');
                    patternGBtn.classList.remove('active');
                    patternHBtn.classList.remove('active');
                    patternIBtn.classList.add('active');
                });
            };

            // 모든 탭 설정 함수 실행
            setupFunctionWordsTabs();
            setupPatternABCTabs();
            setupPatternDEFGHITabs();
        };

        // 모든 초기화 작업 실행
        setupQuizNavigation();
        setupSolutionToggles();
        setupAllTabs();

        // DOM 변경 감지를 위한 MutationObserver 설정
        const observerOptions = {
            childList: true,
            subtree: true
        };

        // DOM 변경 시 설정 다시 실행
        const observer = new MutationObserver(() => {
            setupSolutionToggles();
            setupQuizNavigation();
            setupAllTabs();
        });

        // document.body에 옵저버 연결
        observer.observe(document.body, observerOptions);

        // 컴포넌트 언마운트 시 옵저버 정리
        return () => {
            observer.disconnect();

            // 전역 변수 정리
            delete window.toggleSolutionAlt;
            delete window.toggleSolution;
            delete window.checkAnswers;
        };
    }, []);

    const setupSolutionToggles = () => {
        const solutionToggles = document.querySelectorAll('.solution-toggle');
        solutionToggles.forEach(toggle => {
            // 이미 이벤트가 붙었는지 확인
            if (!toggle.getAttribute('data-event-attached')) {
                if (toggle.getAttribute('data-solution-type') === 'alt') {
                    toggle.addEventListener('click', function () {
                        window.toggleSolutionAlt(this);
                    });
                } else {
                    toggle.addEventListener('click', function () {
                        window.toggleSolution(this);
                    });
                }
                toggle.setAttribute('data-event-attached', 'true');
            }
        });
    };

    const getMaxQuestions = () => {
        const selected = quizTopics.find(t => t.value === newLessonTopic);
        return selected ? selected.max : 0;
    };

    // lessonDetail과 courseDetail를 기반으로 파일 경로 계산 함수
    const computeFilePath = () => {
        if (!courseDetail || !lessonDetail) return '';
        let folderType;
        if (courseDetail.type.toLowerCase() === 'eng' || courseDetail.type.toLowerCase() === 'english') {
            folderType = 'English';
        } else if (courseDetail.type.toLowerCase() === 'math') {
            folderType = 'Math';
        } else {
            folderType = courseDetail.type;
        }
        const folderName = courseDetail.name;
        const sanitizedTitle = lessonDetail.title.replace(/\s+/g, '_');
        // quiz 타입도 html 파일로 취급
        const extension = (lessonDetail.type === 'html' || lessonDetail.type === 'quiz') ? '.html' : '.md';
        return `Class_Materials/${folderType}/${folderName}/${sanitizedTitle}${extension}`;
    };

    // htmlPath를 computeFilePath()로 계산
    const htmlPath = computeFilePath();

    // HTML 파일을 가져와 content 상태에 저장하는 fetchHTML 함수
    useEffect(() => {
        const fetchHTML = async () => {
            try {
                const url = `${htmlPath}`;
                const response = await axios.get(BASELINE + url, { responseType: 'text' });
                const text = response.data;

                const parser = new DOMParser();
                const doc = parser.parseFromString(text, 'text/html');

                // head에 포함된 link[rel="stylesheet"] 태그들을 찾아 document.head에 추가
                const headLinks = doc.head.querySelectorAll('link[rel="stylesheet"]');
                headLinks.forEach(link => {
                    const href = link.getAttribute('href');
                    if (!document.querySelector(`link[href="${href}"]`)) {
                        const newLink = document.createElement('link');
                        newLink.rel = 'stylesheet';
                        newLink.href = href;
                        if (link.getAttribute('integrity')) {
                            newLink.integrity = link.getAttribute('integrity');
                        }
                        if (link.getAttribute('crossorigin')) {
                            newLink.crossOrigin = link.getAttribute('crossorigin');
                        }
                        document.head.appendChild(newLink);
                    }
                });

                // body 내용 추출 (없으면 전체 텍스트 사용)
                let bodyContent = text;
                if (text.includes('<body>') && text.includes('</body>')) {
                    const bodyMatch = text.match(/<body[^>]*>([\s\S]*)<\/body>/i);
                    if (bodyMatch && bodyMatch[1]) {
                        bodyContent = bodyMatch[1];
                    }
                }
                setContent(bodyContent);
            } catch (err) {
                console.error('Error fetching HTML:', err);
            }
        };

        // htmlPath가 존재할 때 fetchHTML 호출
        if (htmlPath) {
            fetchHTML();
        }
    }, [htmlPath]);

    // 파일 불러오기 (loadFile) 함수 – 모든 타입에서 사용
    const loadFile = async () => {
        const filePath = computeFilePath();
        if (!filePath) return;
        try {
            const response = await axios.get(`${BASELINE}api/file`, { params: { path: filePath } });
            if (response.data.success) {
                setContent(response.data.content);
            } else {
                alert("Error loading file: " + response.data.message);
            }
        } catch (error) {
            console.error("Error loading file:", error);
            alert("Failed to load file.");
        }
    };

    // 파일 저장 함수
    const saveFile = async () => {
        const filePath = computeFilePath();
        if (!filePath) return;
        try {
            const response = await axios.put(`${BASELINE}api/file`, { path: filePath, content });
            if (response.data.success) {
                alert("File saved successfully");
            } else {
                alert("Error saving file: " + response.data.message);
            }
        } catch (error) {
            console.error("Error saving file:", error);
            alert("Failed to save file.");
        }
    };

    // course와 전체 lesson 목록 불러오기
    useEffect(() => {
        if (cid) {
            axios.get(`${BASELINE}api/lessons`, { params: { course_id: cid } })
                .then(res => {
                    if (res.data.success) {
                        const sortedLessons = res.data.lessons.sort((a, b) => a.order_index - b.order_index);
                        setAllLessons(sortedLessons);
                        if (lid) {
                            const lesson = sortedLessons.find(l => String(l.id) === String(lid));
                            if (lesson) {
                                setLessonDetail(lesson);
                                // quiz 타입일 경우에도 편집 시 html로 처리
                                setLessonType((lesson.type === 'quiz') ? 'html' : lesson.type);
                            } else {
                                alert("Lesson not found");
                            }
                        }
                    } else {
                        alert("Error fetching lessons: " + res.data.message);
                    }
                })
                .catch(err => {
                    console.error("Error fetching lessons", err);
                });
        }
    }, [cid, lid]);

    // courseDetail 불러오기
    useEffect(() => {
        if (cid) {
            axios.get(`${BASELINE}api/courses`)
                .then(res => {
                    if (res.data.success) {
                        const course = res.data.courses.find(c => String(c.id) === String(cid));
                        if (course) {
                            setCourseDetail(course);
                        } else {
                            alert("Course not found");
                        }
                    } else {
                        alert("Error fetching course details: " + res.data.message);
                    }
                })
                .catch(err => {
                    console.error("Error fetching course details", err);
                });
        }
    }, [cid]);

    // lessonDetail와 courseDetail가 모두 로드되면 파일 자동 불러오기 (모든 타입에 대해)
    useEffect(() => {
        if (lessonDetail && courseDetail) {
            loadFile();
        }
    }, [lessonDetail, courseDetail]);

    // Katex 스크립트 로드 및 auto-render (수학 구문 렌더링)
    useEffect(() => {
        const script2 = document.createElement("script");
        script2.src =
            "https://cdn.jsdelivr.net/npm/katex@0.16.9/dist/contrib/auto-render.min.js";
        script2.integrity =
            "sha384-+VBxd3r6XgURycqtZ117nYw44OOcIax56Z4dCRWbxyPt0Koah1uHoK0o4+/RRE05";
        script2.crossOrigin = "anonymous";
        script2.defer = true;

        script2.onload = () => {
            const elements = document.querySelectorAll(".box-item-left, .stem-content");
            elements.forEach((element) => {
                if (window.renderMathInElement) {
                    window.renderMathInElement(element, {
                        delimiters: [
                            { left: "$$", right: "$$", display: false },
                            { left: "$", right: "$", display: false },
                            { left: "\\(", right: "\\)", display: false },
                            { left: "\\[", right: "\\]", display: true },
                            { left: "\\begin{array}", right: "\\end{array}", display: true },
                        ],
                        throwOnError: false,
                    });
                }
            });
            setIsKatexRendered(true);
        };
        document.body.appendChild(script2);
        return () => {
            document.body.removeChild(script2);
        };
    }, []);

    // content이나 lessonType 변경 시 미리보기 영역 내 수학 구문 재렌더링
    useEffect(() => {
        if (isKatexRendered && previewRef.current && window.renderMathInElement) {
            window.renderMathInElement(previewRef.current, {
                delimiters: [
                    { left: "$$", right: "$$", display: false },
                    { left: "$", right: "$", display: false },
                    { left: "\\(", right: "\\)", display: false },
                    { left: "\\[", right: "\\]", display: true },
                    { left: "\\begin{array}", right: "\\end{array}", display: true },
                ],
                throwOnError: false,
            });
        }
    }, [content, lessonType, isKatexRendered]);

    const handleCodeChange = (e) => {
        setContent(e.target.value);
    };

    // 커서 위치에 before/after 텍스트 삽입
    const insertTextAtCursor = (before, after = '') => {
        const textarea = textareaRef.current;
        if (!textarea) return;
        const start = textarea.selectionStart;
        const end = textarea.selectionEnd;
        const selectedText = content.substring(start, end);
        const newText = content.substring(0, start) + before + selectedText + after + content.substring(end);
        setContent(newText);
        setTimeout(() => {
            textarea.focus();
            textarea.selectionStart = textarea.selectionEnd = start + before.length + selectedText.length;
        }, 0);
    };

    const handleBold = () => {
        if (lessonType === 'markdown') {
            insertTextAtCursor('**', '**');
        } else {
            insertTextAtCursor('<b>', '</b>');
        }
    };

    const handleItalic = () => {
        if (lessonType === 'markdown') {
            insertTextAtCursor('*', '*');
        } else {
            insertTextAtCursor('<i>', '</i>');
        }
    };

    const handleUnderline = () => {
        insertTextAtCursor('<u>', '</u>');
    };

    const handleBulletPoint = () => {
        if (lessonType === 'markdown') {
            insertTextAtCursor('\n- ');
        } else {
            insertTextAtCursor('<li>', '</li>');
        }
    };

    const handleHighlight = () => {
        insertTextAtCursor('<mark>', '</mark>');
    };

    // Add the handleVideoEmbed function
    const handleVideoEmbed = () => {
        const videoEmbedTemplate = `<div style="display: flex; justify-content: center; margin: 20px 0;">
        <video width="80%" controls controlsList="nodownload nofullscreen noremoteplayback" 
            playsinline oncontextmenu="return false;" loop>
            <source src="https://p-vault.com:8083/Class_Materials/Math/YOUR_VIDEO_PATH_HERE" type="video/mp4">
            Your browser does not support the video tag.
        </video>
    </div>`;
        
        // Copy to clipboard
        navigator.clipboard.writeText(videoEmbedTemplate)
            .then(() => {
                alert("Video embed code copied to clipboard! Just add your specific video path after the base URL.");
            })
            .catch(err => {
                console.error('Failed to copy: ', err);
                // Fallback - create a temporary textarea
                const textArea = document.createElement("textarea");
                textArea.value = videoEmbedTemplate;
                document.body.appendChild(textArea);
                textArea.select();
                document.execCommand("copy");
                document.body.removeChild(textArea);
                alert("Video embed code copied to clipboard! Just add your specific video path after the base URL.");
            });
    };

    // 렌더링할 내용 결정 (모든 타입에 대해 정상적으로 렌더링)
    const renderedOutput = lessonType === 'markdown' ? marked(content) : content;

    // 현재 lesson index 계산 (allLessons에서)
    const currentIndex =
        allLessons && lessonDetail
            ? allLessons.findIndex(l => String(l.id) === String(lessonDetail.id))
            : -1;

    // Next/Back 버튼 핸들러
    const goToPreviousLesson = () => {
        if (currentIndex > 0) {
            const prevLesson = allLessons[currentIndex - 1];
            navigate(`/dev/class/${cid}/lesson/edit/${prevLesson.id}`);
        }
    };
    const goToNextLesson = () => {
        if (allLessons && currentIndex >= 0 && currentIndex < allLessons.length - 1) {
            const nextLesson = allLessons[currentIndex + 1];
            navigate(`/dev/class/${cid}/lesson/edit/${nextLesson.id}`);
        }
    };

    // Create Lesson 모달 제출 핸들러
    const handleCreateLessonSubmit = async (e) => {
        e.preventDefault();
        const newLessonData = {
            course_id: cid,
            title: newLessonTitle,
            content: newLessonContent,
            order: 0,
            status: newLessonStatus,
            type: newLessonType,
        };
        if (newLessonType === 'quiz') {
            newLessonData.topic = newLessonTopic;
            newLessonData.questions = newLessonQuestions;
        } else {
            newLessonData.topic = '';
            newLessonData.questions = null;
        }
        try {
            const response = await axios.post(`${BASELINE}api/lessons`, newLessonData, {
                headers: { 'Content-Type': 'application/json' }
            });
            if (response.data.success) {
                const updatedLessons = [...allLessons, { id: response.data.id, ...newLessonData }];
                updatedLessons.sort((a, b) => a.order_index - b.order_index);
                setAllLessons(updatedLessons);
                setIsCreateModalOpen(false);
                navigate(`/dev/class/${cid}/lesson/edit/${response.data.id}`);
            } else {
                alert("Error: " + response.data.message);
            }
        } catch (error) {
            console.error("Error creating lesson:", error);
            alert("Failed to create lesson. Please try again.");
        }
    };

    // content 상태에 있는 모든 <div class="question-label-box">#</div> 를 순차 숫자로 채우는 함수
    const fillNumbers = () => {
        let counter = 1;
        // 정규식 패턴: 정확히 <div class="question-label-box">#</div> 와 일치하는 부분 모두 찾음
        const newContent = content.replace(/<div class="question-label-box">#<\/div>/g, () => {
            return `<div class="question-label-box">${counter++}</div>`;
        });
        setContent(newContent);
    };

    return (
        <div className="flex flex-col h-screen">
            {/* 상단 네비게이션 */}
            <div className="p-4 flex justify-between items-center">
                <button
                    className="px-4 py-2 bg-gray-300 rounded"
                    onClick={() => navigate(`/dev/class/${cid}/lesson`)}
                >
                    Back to List
                </button>
                <div className="space-x-2">
                    <button
                        className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50"
                        onClick={goToPreviousLesson}
                        disabled={currentIndex <= 0}
                    >
                        Previous Lesson
                    </button>
                    <button
                        className="px-4 py-2 bg-blue-500 text-white rounded disabled:opacity-50"
                        onClick={goToNextLesson}
                        disabled={currentIndex < 0 || currentIndex >= allLessons.length - 1}
                    >
                        Next Lesson
                    </button>
                    <button
                        className="px-4 py-2 bg-green-500 text-white rounded"
                        onClick={() => setIsCreateModalOpen(true)}
                    >
                        Create Lesson
                    </button>
                    <button
                        className="px-4 py-2 bg-purple-500 text-white rounded"
                        onClick={() => setIsRegenerateModalOpen(true)}
                    >
                        Re-Generate
                    </button>

                    {lessonDetail?.type === 'quiz' && (
                        <button
                            className="px-4 py-2 bg-red-500 text-white rounded"
                            onClick={() => setIsQuizEditModalOpen(true)}
                        >
                            Quiz Edit
                        </button>
                    )}

                </div>
            </div>

            {/* 상단에 Course명, Lesson명, 타입 표시 (Save 버튼 위) */}
            <div className="text-center mb-4">
                <h1 className="text-3xl font-bold">
                    {courseDetail ? courseDetail.name : 'Loading Course...'}
                </h1>
                <h2 className="text-2xl">
                    {lessonDetail ? lessonDetail.title : 'Loading Lesson...'}{" "}
                    {lessonDetail ? `(${lessonDetail.type.toUpperCase()})` : ''}
                </h2>
            </div>

            {/* 파일 저장 버튼 (Save) */}
            <div className="flex justify-center items-center p-2">
                <button
                    className="px-3 py-1 bg-blue-500 text-white rounded"
                    onClick={saveFile}
                >
                    Save File
                </button>
            </div>

            {/* 마크로 툴바 */}
            {lessonDetail && (
                <div className="flex justify-center items-center p-2 space-x-2">
                    <button className="px-3 py-1 bg-gray-300 rounded" onClick={handleBold}>Bold</button>
                    <button className="px-3 py-1 bg-gray-300 rounded" onClick={handleItalic}>Italic</button>
                    <button className="px-3 py-1 bg-gray-300 rounded" onClick={handleUnderline}>Underline</button>
                    <button className="px-3 py-1 bg-gray-300 rounded" onClick={handleBulletPoint}>Bullet</button>
                    <button className="px-3 py-1 bg-gray-300 rounded" onClick={handleHighlight}>Highlight</button>
                    <button className="px-3 py-1 bg-gray-300 rounded" onClick={fillNumbers}>Fill the #</button>
                    <button className="px-3 py-1 bg-blue-500 text-white rounded" onClick={handleVideoEmbed}>Video Embed</button>
                </div>
            )}

            {/* 코드 작성 및 미리보기 영역 */}
            <div className="flex flex-col md:flex-row flex-1">
                {/* 에디터 영역 */}
                <div className="md:w-1/2 p-4">
                    <textarea
                        ref={textareaRef}
                        className="w-full h-full border border-gray-300 rounded p-2"
                        value={content}
                        onChange={handleCodeChange}
                        placeholder={`Type your ${lessonType} code here...`}
                    />
                </div>
                {/* 미리보기 영역 */}
                <div className="md:w-1/2 p-4 border-l bg-gray-900 overflow-auto">
                    <div ref={previewRef} className="content prose max-w-none"
                        dangerouslySetInnerHTML={{ __html: renderedOutput }} />
                </div>
            </div>

            {/* Create Lesson Modal */}
            {isCreateModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-10">
                    <div className="bg-white p-6 rounded-lg w-96">
                        <h2 className="text-xl font-bold mb-4">Create New Lesson</h2>
                        <form onSubmit={handleCreateLessonSubmit}>
                            <div className="mb-4">
                                <label className="block mb-1 font-medium">Title</label>
                                <input
                                    type="text"
                                    value={newLessonTitle}
                                    onChange={(e) => setNewLessonTitle(e.target.value)}
                                    className="w-full border border-gray-300 rounded px-3 py-2"
                                    required
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block mb-1 font-medium">Type</label>
                                <select
                                    value={newLessonType}
                                    onChange={(e) => setNewLessonType(e.target.value)}
                                    className="w-full border border-gray-300 rounded px-3 py-2"
                                >
                                    <option value="html">HTML</option>
                                    <option value="markdown">Markdown</option>
                                    <option value="quiz">Quiz</option>
                                </select>
                            </div>
                            {newLessonType === 'quiz' && (
                                <>
                                    <div className="mb-4">
                                        <label className="block mb-1 font-medium">Topic</label>
                                        <select
                                            value={newLessonTopic}
                                            onChange={(e) => setNewLessonTopic(e.target.value)}
                                            className="w-full border border-gray-300 rounded px-3 py-2"
                                        >
                                            {quizTopics.map(topic => (
                                                <option key={topic.value} value={topic.value}>
                                                    {topic.label} (Max {topic.max})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="mb-4">
                                        <label className="block mb-1 font-medium">Questions</label>
                                        <div className="flex items-center">
                                            <input
                                                type="number"
                                                value={newLessonQuestions}
                                                onChange={(e) => setNewLessonQuestions(e.target.value)}
                                                className="w-full border border-gray-300 rounded px-3 py-2"
                                                min="1"
                                                max={getMaxQuestions()}
                                                required
                                            />
                                            <span className="ml-2">/ {getMaxQuestions()}</span>
                                        </div>
                                    </div>
                                </>
                            )}
                            <div className="mb-4">
                                <label className="block mb-1 font-medium">Content</label>
                                <textarea
                                    value={newLessonContent}
                                    onChange={(e) => setNewLessonContent(e.target.value)}
                                    className="w-full border border-gray-300 rounded px-3 py-2"
                                />
                            </div>
                            <div className="mb-4">
                                <label className="block mb-1 font-medium">Status</label>
                                <select
                                    value={newLessonStatus}
                                    onChange={(e) => setNewLessonStatus(e.target.value)}
                                    className="w-full border border-gray-300 rounded px-3 py-2"
                                >
                                    <option value="open">open</option>
                                    <option value="maintance">maintance</option>
                                </select>
                            </div>
                            <div className="flex justify-end">
                                <button
                                    type="button"
                                    onClick={() => setIsCreateModalOpen(false)}
                                    className="mr-2 px-4 py-2 border rounded"
                                >
                                    Close
                                </button>
                                <button
                                    type="submit"
                                    className="px-4 py-2 bg-blue-500 text-white rounded"
                                >
                                    Create
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Add the ContentRegeneratorModal */}
            <ContentRegeneratorModal
                isOpen={isRegenerateModalOpen}
                onClose={() => setIsRegenerateModalOpen(false)}
                htmlContent={content}
                onContentRegenerated={handleContentRegenerated}
            />

            <QuizEditModal
                isOpen={isQuizEditModalOpen}
                onClose={() => setIsQuizEditModalOpen(false)}
                htmlContent={content}
            />
        </div>
    );
};

export default LessonEditor;
